module.exports = __webpack_public_path__ + "1d078da4bce02d8ecad1a1f8ba84bd64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-3.png
// module id = 1713
// module chunks = 0